import { render, staticRenderFns } from "./ShopProperties.vue?vue&type=template&id=06ac7dd4&scoped=true"
import script from "./ShopProperties.vue?vue&type=script&lang=js"
export * from "./ShopProperties.vue?vue&type=script&lang=js"
import style0 from "./ShopProperties.vue?vue&type=style&index=0&id=06ac7dd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac7dd4",
  null
  
)

export default component.exports